import { FleekError } from './FleekError';

type ProjectsNotFoundErrorOptions = Record<string, never>;

export class ProjectsNotFoundError extends FleekError<ProjectsNotFoundErrorOptions> {
  public name = 'ProjectsNotFoundError';

  constructor() {
    super({});
  }

  toString = () => 'No projects found.';
}
